import { Message } from '@gonfalon/messages/Message';

import './SkipToContent.css';

export const SkipToContent = () => (
  <a className="SkipToContent" href="#start-of-content">
    <Message id="chrome.skipToContent.skipToContent" />
  </a>
);
